export const imageListItem = ({
  member_id,
  member_attachment_id,
  description,
  sub_label
}) => {
  return [
    /* eslint-disable react/jsx-key */
    {
      type: "webImage",
      url: `/get_image/large?member_id=${member_id}&member_attachment_id=${member_attachment_id}`,
      size: 100,
      align: "left"
    },
    {
      type: "text",
      title: description,
      params: "primary"
    },
    {
      type: "text",
      title: sub_label
    }
  ];
};
